<template>
  <b-col
    xl="2"
    lg="3"
    md="4"
    sm="6"
    cols="6"
    class="user-card mb-1"
  >
    <div class="image">
      <router-link :to="_route">
        <div
          class="img-overlay"
          @click="gtmUserDetail"
        >
          <b-img-lazy
            fluid
            center
            blank-color="#ccc"
            class="user-image"
            :src="user.profile.image"
          />
        </div>
      </router-link>
      <div class="description">
        <div class="interests">
          <div v-if="user.interests">
            <b-badge
              v-for="(interest, index) in user.interests.slice(0, 2)"
              :key="index"
              variant="dark"
            >
              {{ interest.name }}
            </b-badge>
            <b-badge
              v-if="user.interests.length > 2"
              :id="'interests-tooltip-' + uuid"
              variant="dark"
            >
              +{{ user.interests.length - 2 }}
            </b-badge>
            <b-tooltip
              :target="'interests-tooltip-' + uuid"
              triggers="hover"
            >
              <p
                v-for="(interest, index) in user.interests.slice(2)"
                :key="index"
              >
                {{ interest.name }}
              </p>
            </b-tooltip>
          </div>
          <div
            v-if="user.voiceRoomInfo"
            class="stream-link-wrapper live-badge-wrapper"
          >
            <span
              class="live-badge"
              @click="goToStream"
            >
              <!-- Video Icon -->
              <svg v-if="user.streamInfo" xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" class="feather feather-video"><polygon points="23 7 16 12 23 17 23 7"></polygon><rect x="1" y="5" width="15" height="14" rx="2" ry="2"></rect></svg>
              <!-- Voice Icon -->
              <svg v-else-if="user.voiceRoomInfo" xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" class="feather feather-mic"><path d="M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z"></path><path d="M19 10v2a7 7 0 0 1-14 0v-2"></path><line x1="12" y1="19" x2="12" y2="23"></line><line x1="8" y1="23" x2="16" y2="23"></line></svg>
              Live
            </span>
          </div>
        </div>
        <div style="z-index: 3">
          <router-link :to="_route">
            <div
              class="name"
              @click="gtmUserDetail"
            >
              <span class="mr-05">
                {{ user.userName }}
              </span>
              <span v-if="user.profile.year">
                {{ new Date().getFullYear() - user.profile.year }}
              </span>
            </div>
            <div
              v-if="user.profile.country"
              class="country"
            >
              {{ $t('countries.' + user.profile.country) }}
            </div>
            <div class="status-live-wrapper">
              <div class="d-flex gap-12">
                <status-indicator2 :user="user" />
                <div v-if="user.profile.onlineStatus === 'online'">
                  <span
                    class="available-badge"
                    :style="!isAvailable ? 'background-color: #f59292 !important;' : ''"
                  >
                    {{ isAvailable ? $t('Available') : $t('Busy') }}
                  </span>
                </div>
              </div>
            </div>
          </router-link>
          <div class="shortcuts">
<!--            <div class="heart" :class="{'is-fav': isFavorite}">-->
<!--              <b-img :src="iconHeartWhite" height="20" width="20"-->
<!--                     @click="isFavorite ? unlike() : like()"/>-->
<!--            </div>-->
            <router-link
              v-if="false"
              :to="_route"
              style="z-index: 3"
            >
              <div
                class="chat"
                @click="gtmGoChat"
              >
                <b-img
                  :src="iconChatWhite"
                  height="20"
                  width="20"
                />
              </div>
            </router-link>
            <div
              v-if="user.profile.voiceOn"
              class="phone"
            >
              <b-img
                :src="iconCall"
                height="20"
                width="20"
                @click="call"
              />
            </div>
            <div
              v-if="user.profile.cameraOn && userCanStartVideoCall"
              class="video-call"
            >
              <b-img
                :src="iconCamera"
                height="20"
                width="20"
                @click="videoCall"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </b-col>
</template>

<script>
import useJwt from '@/auth/jwt/useJwt'
import {
  BBadge, BCol, BImg, BImgLazy, BTooltip,
} from 'bootstrap-vue'
import { gtmTrackNewEvent, showNotify, throwDefaultError } from '@/helpers/helpers'
// eslint-disable-next-line import/extensions
import StatusIndicator2 from '@/components/StatusIndicator2'
import { subscribeVideoRoomService } from '@/services/VideoRoomService'
import { subscribeVoiceRoom } from '@/services/VoiceRoomService'

const iconChatWhite = require('@/assets/images/icons/chat-white.svg')
const iconHeartWhite = require('@/assets/images/icons/heart-white.svg')
const iconHeartEmpty = require('@/assets/images/icons/heart-empty.svg')
const iconCall = require('@/assets/images/icons/call2.svg')
const iconCamera = require('@/assets/images/icons/camera.svg')
const iconPhoneWhite = require('@/assets/images/icons/phone-white.svg')
const iconVideoCall = require('@/assets/images/icons/video-call.svg')

export default {
  components: {
    BBadge,
    BCol,
    BImg,
    BImgLazy,
    BTooltip,

    StatusIndicator2,
  },
  props: {
    order: {
      type: Number,
      default: 0,
    },
    showLoginRoute: {
      type: Boolean,
      default: false,
    },
    user: {
      type: Object,
      required: true,
    },
    callSource: {
      type: String,
      default: 'home_list_1',
    },
  },
  data() {
    return {
      iconChatWhite,
      iconHeartWhite,
      iconHeartEmpty,
      iconCall,
      iconCamera,
      iconPhoneWhite,
      iconVideoCall,
      isFavorite: this.user.fav,
    }
  },
  computed: {
    // eslint-disable-next-line no-underscore-dangle
    _route() {
      if (this.showLoginRoute) {
        return {
          name: 'login',
        }
      }
      return {
        name: 'users.show',
        params: {
          id: this.user.id,
        },
      }
    },
    gtmCategory() {
      switch (this.$route.name) {
        case 'discover':
          return 'Kesfet'
        case 'users.favorites':
          return 'Favorites'
        case 'users.search':
          return 'Search'
        default:
          return 'UserCard'
      }
    },
    isAvailable() {
      return this.user && this.user.profile.onlineStatus === 'online' && !this.user.profile.busyInCall
    },
    userCanStartVideoCall() {
      return this.$store.getters['auth/userCanStartVideoCall']
    },
    uuid() {
      return Math.random() * 100000
    },
  },
  mounted() {
    // Log the user prop data when the component is mounted
    // console.log('UserCard user prop:', this.user);
  },
  methods: {
    call() {
      this.$store.dispatch('app/setModalCallType', 'audio')
      this.$store.dispatch('app/setCallDetails', {
        callSource: this.callSource,
        userOrder: this.order,
      })
      this.$store.dispatch('app/setModalCall', false)
      setTimeout(() => {
        this.$store.dispatch('app/setModalCallUser', this.user)
        this.$store.dispatch('app/setModalCall', true)
      }, 33)
      // if (this.user?.profile?.callType == 2) {
      //   this.$store.dispatch('app/setModalDownloadMobileApp', true)
      // } else {
      //   if (!this.$store.getters['auth/userPhoneNumber']) {
      //     this.$store.dispatch('app/setModalAddPhoneNumberShowDiamond', false)
      //     this.$store.dispatch('app/setModalAddPhoneNumber', true)
      //     this.$store.dispatch('app/setVerificationType', 'phone')
      //   } else {
      //     this.$emit('setLoading', true)
      //     useJwt.callUser(this.user.id)
      //         .then(response => {
      //           showNotify(this.$toast, 'Arama başarılı', 'success')
      //
      //           gtmTrackNewEvent('call', {
      //             category: this.gtmCategory,
      //             action: 'Call',
      //             label: this.user.id
      //           })
      //         })
      //         .catch(error => {
      //           const { response } = error
      //           throwDefaultError(this.$toast, error)
      //           if (response && response.data?.header?.error?.errorCode == 215) {
      //             this.$store.dispatch('app/setModalAddPhoneNumberShowDiamond', false)
      //             this.$store.dispatch('app/setModalAddPhoneNumber', true)
      //             this.$store.dispatch('app/setVerificationType', 'phone')
      //           }
      //         })
      //         .finally(() => this.$emit('setLoading', false))
      //   }
      // }
    },
    gtmGoChat() {
      gtmTrackNewEvent('chatclick', {
        category: this.gtmCategory,
        action: 'ChatClick',
        label: this.user.id,
      })
    },
    gtmUserDetail() {
      gtmTrackNewEvent('userdetail', {
        category: this.gtmCategory,
        action: 'UserDetail',
        label: this.user.id,
      })
    },
    like() {
      this.$emit('setLoading', true)
      useJwt.addFavoriteUser(this.user.id)
        .then(() => {
          showNotify(this.$toast, this.$t('Liking successful'), 'success')
          this.isFavorite = true

          gtmTrackNewEvent('addfavorite', {
            category: this.gtmCategory,
            action: 'AddFavorite',
            label: this.user.id,
          })
        })
        .catch(error => {
          throwDefaultError(this.$toast, error)
        })
        .finally(() => { this.$emit('setLoading', false) })
    },
    unlike() {
      this.$emit('setLoading', true)
      useJwt.removeFavoriteUser(this.user.id)
        .then(() => {
          showNotify(this.$toast, this.$t('Unliking successful'), 'success')
          this.isFavorite = false

          gtmTrackNewEvent('removefavorite', {
            category: this.gtmCategory,
            action: 'RemoveFavorite',
            label: this.user.id,
          })
        })
        .catch(error => {
          throwDefaultError(this.$toast, error)
        })
        .finally(() => { this.$emit('setLoading', false) })
    },
    videoCall() {
      this.$store.dispatch('app/setModalCallType', 'video')
      this.$store.dispatch('app/setCallDetails', {
        callSource: this.callSource,
        userOrder: this.order,
      })
      this.$store.dispatch('app/setModalCall', false)
      setTimeout(() => {
        this.$store.dispatch('app/setModalCallUser', this.user)
        this.$store.dispatch('app/setModalCall', true)
      }, 33)
    },
    async goToStream() {
      // --- Video Room Logic ---
      if (this.user.streamInfo && this.user.streamInfo.channelId) {
        const channelId = this.user.streamInfo.channelId
        const publisherAgoraUid = this.user.streamInfo.agoraUid // Get publisher's UID from the original user data

        if (!publisherAgoraUid) {
          this.$toast({ title: 'Hata', text: 'Yayıncı bilgisi eksik.', variant: 'danger' })
          return
        }

        this.$store.commit('videoRoom/SET_HOST_AGORA_UID', publisherAgoraUid)

        try {
          // Call the new service function
          const roomInfo = await subscribeVideoRoomService(channelId, publisherAgoraUid)

          // If service function succeeds, it returns the roomInfo object
          this.$store.dispatch('videoRoom/setRoomInfo', roomInfo)

          this.$router.push({
            name: 'video-room',
            params: {
              channelId: roomInfo.channelId, // Use channelId from returned roomInfo
              agoraUid: publisherAgoraUid, // Use PUBLISHER's agoraUid from streamInfo for the route param
            },
          })
        } catch (error) {
          // Service function throws an error on failure
          console.error('Error subscribing to video room via service:', error)
          // Service now throws Error with specific message, just display error.message
          showNotify(this.$toast, error.message || 'Video yayınına katılırken beklenmedik bir sorun oluştu.', 'danger')
        }
        return // Stop execution if video room logic was handled
      }

      // --- Voice Room Logic (Fallback) ---
      if (this.user.voiceRoomInfo && this.user.voiceRoomInfo.channelId) {
        const channelId = this.user.voiceRoomInfo.channelId
        try {
          // Call the dedicated service function
          const roomInfo = await subscribeVoiceRoom(channelId)

          // If service call succeeds, it returns the roomInfo object
          this.$store.dispatch('voiceRoom/setRoomInfo', roomInfo) // Use dispatch or commit as appropriate

          // Navigate to the voice room page, using channelId from the returned roomInfo
          this.$router.push({ name: 'voice-room', params: { channelId: roomInfo.channelId } })
        } catch (error) {
          // Handle network or unexpected errors from the service
          console.error('Error subscribing to voice room via service:', error)
          // Service now throws Error with specific message, just display error.message
          showNotify(this.$toast, error.message || 'Ses odasına katılırken beklenmedik bir sorun oluştu.', 'danger')
        } finally {
          // Optional: Reset loading indicator state
          // this.isJoiningStream = false;
        }
      } else {
        // Handle case where neither info object is valid
        console.error('Cannot go to stream: No valid streamInfo or voiceRoomInfo found.')
        this.$toast({ title: 'Hata', text: 'Yayın bilgileri bulunamadı.', variant: 'danger' })
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.user-card {
  padding: 0 4px;
  .image {
    position: relative;
    overflow: hidden;
    width: 100%;
    aspect-ratio: 2/3;
    /* Remove border radius from container to make it rectangular */
    border-radius: 12px;

    /* Make the image rectangular instead of circular */
    .user-image {
      border-radius: 12px;
      height: 100%;
      width: 100%;
      object-fit: cover; /* Ensures the image covers the area properly */
    }

    /* Add overlay to ensure text remains readable */
    .img-overlay {
      position: relative;
      width: 100%;
      height: 100%;

      &::after {
        content: '';
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        background: linear-gradient(to top, rgba(0,0,0,0.7) 0%, rgba(0,0,0,0) 100%);
        z-index: 2;
      }
    }
  }

  .description {
    position: absolute;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    top: 0;
    left: 0;
    height: 100%;
    padding: 14px 12px 18px 12px;
    color: #fff;
    font-family: 'Lexend', sans-serif;
    font-style: normal;
    font-weight: 600;
    font-size: 18px;
    line-height: 22px;
    width: 100%;

    @media (max-width: 767px) {
      font-size: 14px;
      line-height: 17px;
    }
    .interests {
      z-index: 3;
      font-size: 12px;
      * {
        margin-right: 2px;
      }
    }
    .country {
      font-family: 'Lexend', sans-serif;
      font-style: normal;
      font-weight: 400;
      font-size: 12px;
      line-height: 22px;
      color: #FFFFFF;
      margin-bottom: 4px;
    }
    .name {
      display: flex;
      align-items: center;
      gap: 2px;
      z-index: 3 !important;
      font-family: 'Lexend', sans-serif;
      font-style: normal;
      font-weight: 400;
      font-size: 17px !important;
      line-height: 22px;
      color: #FFFFFF;
      margin-bottom: 8px;

      @media (max-width: 767px) {
        font-size: 14px;
        line-height: 17px;
        margin-bottom: 4px;
      }
    }
    .available-badge {
      padding: 6px 4px;
      border-radius: 6px;
      font-family: 'Inter', sans-serif;
      font-style: normal;
      font-weight: 500;
      font-size: 12px;
      color: #5A504E;
      background-color: #d9d9d9;
      text-transform: uppercase;
    }
    .stream-link-wrapper {
      margin-top: 8px;
    }
    .stream-link {
      color: #fff;
      font-size: 12px;
      font-weight: 500;
      text-decoration: underline;
      cursor: pointer;

      &:hover {
        color: #eee;
      }
    }
    .shortcuts {
      display: flex;
      justify-content: center;
      gap: 6px;
      position: absolute;
      right: 12px;
      top: 12px;
      flex-direction: column;
      div {
        z-index: 3 !important;
        background-color: #fff;
        border-radius: 50%;
        padding: 6px;
        cursor: pointer;
        @media (max-width: 767px) {
          padding: 6px;
          img {
            width: 16px;
            height: 16px;
          }
        }

        &.is-fav {
          background: #FF5A5F;
          border: 1px solid #FF5A5F;
        }
      }
    }
  }
}

.status-live-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

// Define the pulsing animation
@keyframes pulse {
  0% {
    transform: scale(1);
    box-shadow: 0 0 0 0 rgba(79, 187, 86, 0.7); // Match background color
  }
  70% {
    transform: scale(1.05);
    box-shadow: 0 0 0 5px rgba(79, 187, 86, 0); // Match background color
  }
  100% {
    transform: scale(1);
    box-shadow: 0 0 0 0 rgba(79, 187, 86, 0); // Match background color
  }
}

.live-badge {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  background-color: #4fbb56;
  color: white;
  padding: 3px 8px;
  border-radius: 4px;
  font-size: 11px;
  font-weight: bold;
  text-transform: uppercase;
  cursor: pointer;
  animation: pulse 1.5s infinite cubic-bezier(0.66, 0, 0, 1); // Apply the animation
  transition: background-color 0.2s;

  &:hover {
    background-color: darken(#5aff65, 10%);
  }
}

// Wrapper for absolute positioning
.live-badge-wrapper {
  position: absolute;
  top: 14px; // Adjust as needed to match padding
  left: 12px; // Adjust as needed to match padding
  z-index: 3;
}
</style>
